module.exports = __webpack_public_path__ + "img/1_3.c24254b8.c24254b8.gif";